import React, { useEffect } from "react";
import { Box, Typography, Grid, Container, useTheme } from "@mui/material";
import service1 from "../../images/service-1.jpg";
import service2 from "../../images/service-2.jpg";
import service3 from "../../images/service-3.jpg";
import service4 from "../../images/service-4.jpg";
import service5 from "../../images/service-5.jpg";
import service6 from "../../images/service-6.jpg";

// import { useMediaQuery } from "@mui/system";
import { useLocation } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';

// Dummy service data
const services  = [
  {
    id: 1,
    title: "Application Services",
    description:
      "End-to-end custom application development and modernization services to transform your business operations. We build scalable, secure, and high-performance applications tailored to your specific needs.",
    image: service1,
  },
  {
    id: 2,
    title: "Managed Services",
    description:
      "Comprehensive IT infrastructure management and 24/7 support services. Our proactive monitoring and maintenance ensure optimal system performance and business continuity.",
    image: service2,
  },
  {
    id: 3,
    title: "AI & Data Science",
    description:
      "Harness the power of artificial intelligence and advanced analytics to drive data-informed decisions. We develop intelligent solutions for predictive analytics, machine learning, and process automation.",
    image: service3,
  },
  {
    id: 4,
    title: "Business Consulting",
    description:
      "Strategic digital transformation consulting to optimize operations and drive growth. Our experts help align technology with business objectives for maximum ROI.",
    image: service4,
  },
  {
    id: 5,
    title: "Cloud Solutions",
    description:
      "End-to-end cloud migration, deployment, and optimization services. We design secure, scalable cloud architectures tailored to your business requirements.",
    image: service5,
  },
  {
    id: 6,
    title: "Cybersecurity Solutions",
    description:
      "Comprehensive security services including risk assessment, threat detection, and compliance management. We protect your critical assets with enterprise-grade security frameworks.",
    image: service6,
  }
];

const ServiceCard = ({ service, index }) => {
  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash; // e.g. #service-3
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 200); // wait a bit to ensure layout has rendered
      }
    }
  }, [location]);

useEffect(() => {
  AOS.init({ duration: 800, once: true });
}, []);

  return (
   <Box
  id={`service-${service.id}`}
  sx={{
    scrollMarginTop: "100px",
    py: 8,
    background: index % 2 === 0
      ? "linear-gradient(to right, rgba(173, 216, 230, 1), rgba(173, 216, 230, 0.3), rgba(255, 192, 203, 0.3), rgba(255, 192, 203, 1))"
      : "linear-gradient(to right, rgba(255, 192, 203, 1), rgba(255, 192, 203, 0.3), rgba(156, 214, 233, 0.2), rgba(156, 214, 233, 1))",
    borderRadius: 5,
    backgroundSize: "200% 200%",
  
    mb: 5
  }}
>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={6}
          alignItems="center"
        >
          <Box sx={{display : "flex" , 
            flexDirection: {xs : index % 2 === 0 ? "column" : "column-reverse" , sm : index % 2 === 0 ? "row" : "row-reverse"},
             }}>
            <Box
              data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}
              component="img"
              src={service.image}
              alt={service.title}
              Priority
              sx={{
                width: {xs : "100%" , sm : "50%"},
                borderRadius: 2,
                boxShadow: 3,
                objectFit: "cover",
                mx: { xs: 0, sm: 4 },
              }}
            />
            <Box 
            data-aos={index % 2 === 0 ? 'fade-left' : 'fade-right'}
            sx={{ px: { xs: 0, md: 4 } }}>
              <Typography
                variant="h4"
                component="h4"
                gutterBottom
                sx={{ fontWeight: 700, color: index % 2 === 0? "#a10204" : "#032262" }}

              >
                {service.title}
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{ fontSize: "1.1rem", lineHeight: 1.8 }}
              >
                {service.description}
              </Typography>
            </Box>
          </Box>

          
        </Grid>
      </Container>
    </Box>
  );
};

const ServicesSection = () => {
  return (
    <Box component="section" id="services">
      {services?.map((service, index) => (
        <ServiceCard key={service.id} service={service} index={index} />
      ))}
    </Box>
  );
};

export default ServicesSection;
